/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleUpgradePreviewGroup } from './moduleUpgradePreviewGroup';

/**
 * Grouped upgrade-offer previews for a draft target version.
 */
export interface ModuleUpgradePreviewResponse {
  targetVersion: string;
  groups?: ModuleUpgradePreviewGroup[];
}
